export default __webpack_public_path__ + "static/media/fechar.8370e430.svg";